import type React from 'react';

interface BlackPlusIconProps {
  size?: number;
  className?: string;
  fill?: string;
}

const BlackPlusIcon: React.FC<BlackPlusIconProps> = ({
  size = 18,
  className = '',
  fill = '#444444'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 19"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 15.5C12.3137 15.5 15 12.8137 15 9.5C15 6.18629 12.3137 3.5 9 3.5C5.68629 3.5 3 6.18629 3 9.5C3 12.8137 5.68629 15.5 9 15.5ZM8.29422 10.2035H6.70047C6.50943 10.2035 6.34493 10.1345 6.20696 9.99646C6.06899 9.85841 6 9.69204 6 9.49734C6 9.30265 6.06899 9.13628 6.20696 8.99823C6.34493 8.86018 6.50943 8.79115 6.70047 8.79115H8.29422V7.20088C8.29422 7.00973 8.36321 6.84513 8.50118 6.70708C8.63915 6.56903 8.80542 6.5 9 6.5C9.19457 6.5 9.36085 6.56903 9.49882 6.70708C9.63679 6.84513 9.70578 7.00973 9.70578 7.20088V8.79115H11.2995C11.4906 8.79115 11.6551 8.86018 11.793 8.99823C11.931 9.13628 12 9.30265 12 9.49734C12 9.69204 11.931 9.85841 11.793 9.99646C11.6551 10.1345 11.4906 10.2035 11.2995 10.2035H9.70578V11.7991C9.70578 11.9903 9.63679 12.1549 9.49882 12.2929C9.36085 12.431 9.19457 12.5 9 12.5C8.80542 12.5 8.63915 12.431 8.50118 12.2929C8.36321 12.1549 8.29422 11.9903 8.29422 11.7991V10.2035Z"
        fill={fill}
      />
    </svg>
  );
};

export default BlackPlusIcon;
